import { createContext, useContext, type ReactNode } from 'react';

/**
 * 페이지 제목 옆에 앱이 끼워 넣는 요소(예: QA-509 즐겨찾기 별). ui 계층은 앱 상태를 모르므로 레이아웃이 Provider 로 준다.
 * 없으면 아무것도 그리지 않는다.
 */
const PageTitleAddonContext = createContext<ReactNode>(null);

export const PageTitleAddonProvider = ({ addon, children }: { addon: ReactNode; children: ReactNode }) => (
  <PageTitleAddonContext.Provider value={addon}>{children}</PageTitleAddonContext.Provider>
);

export const usePageTitleAddon = (): ReactNode => useContext(PageTitleAddonContext);
